export const SCOPE = 'wrex-columns';

export const COLUMN = 'column';
export const COLUMNS = 'columns';
